var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.$t('sortSettings.header')}},[_c('sort-group-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }